import React, { FC } from 'react';
import { StatusTip, Icon, Bubble } from 'tea-component';
import { PieData } from '../../types';
import GaasLineChart from './GaasLineChart';
import CountryPieChart from './CountryPieChart';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import TipContext from '@/pages/home/components/TipContext';
import { useIntl } from 'umi';

const { LoadingTip } = StatusTip;

interface RevenuePercentageProps {
  loading: boolean;
  pieData: PieData[];
  lineData: any[];
  linexAxis: string[];
}

const RevenuePercentage: FC<RevenuePercentageProps> = (props) => {
  const { loading, pieData, lineData, linexAxis } = props;
  const { formatMessage } = useIntl();
  return (
    <div className="dbi-benchmark-rowbox">
      <CardSlotV2
        className="dbi-benchmark-cardbox benchmark-revenue-percentage benchmark-rowbox-card"
        iconList={[]}
        title={
          <>
            <div>{formatMessage({id: 'dbi_benchmark_gass_revenue'})}</div>
            <TipContext
              className="tip-icon"
              AWidth={555}
              placement="top"
              tipText={formatMessage({id: 'dbi_benchmark_gass_revenue_info'})} 
            />
          </>
        }
      >
        {loading ? (
          <LoadingTip className="dbi-benchmark-chart-loading" />
        ) : (
          lineData?.length > 0?  <GaasLineChart
            lineSeries={lineData || []}
            lineXAxis={linexAxis || []}
          />: 
          <div className="dbi_pc_benchmark_no_data-warp" style={{ height: 264 }}>
            {formatMessage({ id: 'dbi_detail_no_data_under' })}
         </div>
        )}
      </CardSlotV2>
      <CardSlotV2
        className="dbi-benchmark-cardbox benchmark-pc-player benchmark-rowbox-card"
        iconList={[]}
        title={
          <>
            <div>{formatMessage({id: 'dbi_benchmark_players_by_Region'})}</div>
            <TipContext
              className="tip-icon"
              AWidth={555}
              placement="top"
              tipText={formatMessage({id: 'dbi_benchmark_players_info'})}
            />
          </>
        }
      >
        {loading ? (
          <LoadingTip className="dbi-benchmark-chart-loading" />
        ) : (
          pieData?.length > 0 ? <CountryPieChart pieData={pieData} />:  
          <div className="dbi_pc_benchmark_no_data-warp" style={{ height: 264 }}>
           {formatMessage({ id: 'dbi_detail_no_data_under' })}
          </div>
        )}
      </CardSlotV2>
    </div>
  );
};

RevenuePercentage.displayName = 'RevenuePercentage';

export default RevenuePercentage;
